import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "counter"]

  connect() {
    this.update()
  }

  update() {
    const current = this.inputTarget.value.length
    const max = this.inputTarget.maxLength
    this.counterTarget.textContent = `${current} / ${max}`
  }
}
